module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "考级中心/考级点",
      "label": "注册或者关联考级中心考级点信息，获取七彩星级申报业务权限"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [(_vm.row.exame_center.kaojiregist_status == 0) ? _c('div', {
          directives: [{
            name: "rblink",
            rawName: "v-rblink",
            value: ({
              name: 'QcxjStationCert'
            }),
            expression: "{name:'QcxjStationCert'}"
          }],
          staticClass: "tiny-btn-1"
        }, [_vm._v("去认证")]) : (_vm.row.exame_center.kaojiregist_status == 3) ? _c('div', {
          directives: [{
            name: "rblink",
            rawName: "v-rblink",
            value: ({
              name: 'QcxjStationResult'
            }),
            expression: "{name:'QcxjStationResult'}"
          }],
          staticClass: "tiny-btn-0"
        }, [_vm._v("认证失败")]) : (_vm.row.exame_center.kaojiregist_status == 1) ? _c('div', {
          directives: [{
            name: "rblink",
            rawName: "v-rblink",
            value: ({
              name: 'QcxjStationResult'
            }),
            expression: "{name:'QcxjStationResult'}"
          }],
          staticClass: "tiny-btn-0"
        }, [_vm._v("审核中")]) : _vm._e()]
      },
      proxy: true
    }])
  }), _vm._v(" "), (_vm.row.exame_center.kaojiregist_status == 2) ? _c('van-cell', {
    attrs: {
      "value": _vm.row.exame_center.danwei
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function() {
        return [_c('van-tag', {
          attrs: {
            "plain": "",
            "type": "success"
          }
        }, [_vm._v("已认证")])]
      },
      proxy: true
    }], null, false, 2624470635)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom-button"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ExameApplyList'
      }),
      expression: "{name:'ExameApplyList'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("七彩星级运动员申报")]), _vm._v(" "), (_vm.row.exame_center.kaojitype == '考级中心') ? _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ExameApplySList'
      }),
      expression: "{name:'ExameApplySList'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("我授权的申报")]) : _vm._e()], 1), _vm._v(" "), _c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ExameApplyJoinMemberList'
      }),
      expression: "{name:'ExameApplyJoinMemberList'}"
    }],
    attrs: {
      "title": "我参加的申报",
      "is-link": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c81ea7a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/QcxjIndex.vue
// module id = 1590
// module chunks = 0